<div class="c-form__field c-form__field--without-label">
    <label class="c-checkbox">
        <input
            class="c-checkbox__input"
            type="checkbox" {required}
            {id}
            checked="{ value }"
            on:change="fire('change', { value: this.value })"
            on:blur="fire('blur')"
            value="on"
        />
        {#if options.label}
            <span class="c-checkbox__label">{ options.label }</span>
        {/if}
    </label>
</div>